import { MutationHookOptions, useMutation } from "@apollo/client";
import setInvoiceAddressGql from "@whoppah/apollo/mutation/setInvoiceAddress.graphql";
import {
  SetInvoiceAddressMutation,
  SetInvoiceAddressMutationVariables,
} from "@whoppah/apollo/schema";

/**
 * WHO-5532. Pins an invoice address; `addressId: null` clears the pin so the
 * invoice follows the delivery address again. The mutation returns the
 * `Merchant` with both role pointers, so the normalized cache patches every
 * `me.merchants[0]` reader on its own.
 */
const useSetInvoiceAddress = (
  options?: MutationHookOptions<
    SetInvoiceAddressMutation,
    SetInvoiceAddressMutationVariables
  >
) => {
  return useMutation(setInvoiceAddressGql, options);
};

export default useSetInvoiceAddress;
